import AssignUnassignButton from "../Drivers/Grid/cellRenderer/AssignUnassignButton";
import React from "react";

interface PreDispatchButtonRendererProps {
    api: {
        runCommand: (command: string, params: { trailer: unknown }) => void;
    };
    data: any;
    node?: {
        data?: any;
    };
}

const PreDispatchButtonRenderer: React.FC<PreDispatchButtonRendererProps> = (props) => {
    const { api, data, node } = props;
    const onPreDispatch = () => {
        api.runCommand("PreDispatch", {
            trailer: node?.data ?? data,
        });
    };
    return (
        <div>
            <AssignUnassignButton
                variant="outlined"
                color="primary"
                disabled={false}
                onClick={onPreDispatch}
                data-automationid="PreDispatch"
            >
                Pre-Dispatch
            </AssignUnassignButton>
        </div>
    );
};

export default PreDispatchButtonRenderer;
